import { useNavigate } from "react-router-dom";
import {
  AlertBanner,
  DateRangePicker,
  CircularLoader,
} from "@components/index";
import { useAppConfig } from "@context/AppConfigContext";
import DashboardSection from "./components/DashboardSection";
import MISDownload from "./components/MISDownload";
import { useHomePage } from "./homeData";

import "./index.scss";

const Home = () => {
  const { user } = useAppConfig();
  const navigate = useNavigate();

  const {
    showGreeting,
    showWarning,
    isClosing,
    isWarningClosing,
    fromDate,
    toDate,
    handleDateChange,
    isLoading,
    dashboardData,
    isBalanceLow,
    handleCardNavigation,
    handleCloseAlertBanner,
  } = useHomePage(user);

  return (
    <div className="home-page">
      <div className="home-page__header">
        <AlertBanner
          message="Hello"
          data={user?.user.name}
          showGreeting={showGreeting}
          isClosing={isClosing}
          onClose={() => handleCloseAlertBanner("atp-greeting-dismissed")}
        />

        {isBalanceLow && (
          <AlertBanner
            message={
              <div className="home-page__header-banner">
                Your wallet balance is low, Please add funds.
                <button
                  onClick={() => navigate("/cd-balance-claims")}
                  className="home-page__header-banner-button"
                >
                  Add Funds
                </button>
              </div>
            }
            showGreeting={showWarning}
            isClosing={isWarningClosing}
            onClose={() => handleCloseAlertBanner("atp-warning-dismissed")}
            type="warning"
            isBannerClosable={false}
          />
        )}
      </div>
      <div className="lob-dashboard__header">
        <h2 className="lob-dashboard__title">Dashboard Overview</h2>
        <DateRangePicker
          fromDate={fromDate}
          toDate={toDate}
          onChange={handleDateChange}
          label="Select Date Range"
          showClearButton
          className="lob-dashboard_date-range-picker"
        />
      </div>
      {/* Dashboard card section  */}
      <div className="lob-dashboard">
        {isLoading && <CircularLoader />}
        {Object.entries(dashboardData).map(([sectionKey, section]) => (
          <DashboardSection
            key={sectionKey}
            section={section}
            cards={section.cards}
            data={dashboardData}
            onCardClick={handleCardNavigation}
            type="lob"
            loading={isLoading}
          />
        ))}
      </div>

      <div className="MIS_section_container">
        <div className="mis-section-header">
          <h3>MIS Reports Download</h3>
          <p>Select and download Management Information System reports</p>
        </div>

        <MISDownload size="medium" className="mis-download-section" />
      </div>
    </div>
  );
};

export default Home;
